module.exports = __webpack_public_path__ + "static/media/stone-opacity.7c13453d.png";